"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/FileMessage/MediaTile.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _PlayGlyph = require('./PlayGlyph'); var _PlayGlyph2 = _interopRequireDefault(_PlayGlyph);







const MediaTile = ({ kind, fileName, onClick }) => (
  _react2.default.createElement('button', {
    type: "button",
    className: _classBuilder2.default.call(void 0, 'file-message--media-tile', `file-message--media-tile--${kind}`),
    onClick: onClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 12}}

    , _react2.default.createElement('span', { className: "file-message--media-tile--glyph", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 17}}
      , kind === 'video' ? _react2.default.createElement(_PlayGlyph2.default, { size: 18, __self: this, __source: {fileName: _jsxFileName, lineNumber: 18}} ) : '▧'
    )
    , _react2.default.createElement('span', { className: "file-message--media-tile--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 20}}, fileName)
  )
)

exports. default = MediaTile
